import InputSearch from "./Input";
import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchResults from "./SearchResults";
import SearchWrapper, {
  SearchBoxWrapper,
  CurrentType,
} from "./SearchBox.style";
// import { Html5Qrcode } from 'html5-qrcode';
import { SearchIcon } from "../AllSvgIcon";
import { FaSearch, FaCamera, FaQrcode } from "react-icons/fa";
import { Alert } from "react-bootstrap";
import { Toggle_Suggestions } from "../../store/actions/productAction";
import { debounce, every } from "lodash";
import { useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { logSearchQuery } from "../../services/googleAnalytics";
// import WebCam from "./WebCam";
import { useDeviceType } from "../../helper/useDeviceType";
import { baseUrl } from "../../constants/Constant";

// Hidden container required by html5-qrcode's scanFile()
const QR_READER_ELEMENT_ID = "html5qr-hidden-reader";

const Search = ({
  suggestions,
  buttonText,
  buttonIcon,
  inputStyle,
  style,
  bordered,
  hideType,
  showSvg,
  autoSuggestion,
  className,
  handleSearch,
  onClick,
  value,
  expand,
  minimal,
  props,
  setCount,
  userAgent,
}) => {
  const deviceType = useDeviceType(userAgent);
  const mobile = deviceType.mobile;
  const history = useHistory();
  const [detectedBarcode, setDetectedBarcode] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [toggleSuggestion, setToggleSuggestion] = useState(false);
  const [toggleSearch, setToggleSearch] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const searchRef = useRef(null);
  const webcamRef = useRef(null);
  // At the top inside your component
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  const [showWebCam, setShowWebCam] = useState(false);
  const [captureImage, setCaptureImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [base64Image, setBase64Image] = useState(null);
  const [enterPressed, setEnterPressed] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [scanAttempts, setScanAttempts] = useState(0);
  const [barcodeHints, setBarcodeHints] = useState('');
  const [isCameraActive, setIsCameraActive] = useState(false);
  const barcodeReaderRef = useRef(null);
  const cameraInputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);

    return () => {
      document.removeEventListener("click", handleClickOutside, false);
      if (barcodeReaderRef.current) {
        try {
          barcodeReaderRef.current.clear();
        } catch (err) {
          // Ignore if nothing to clear
        }
        barcodeReaderRef.current = null;
      }
    };
  }, []);

  // Lazily create a single html5-qrcode instance bound to the hidden container
  const getBarcodeReader = () => {
    if (!barcodeReaderRef.current) {
      // barcodeReaderRef.current = new Html5Qrcode(QR_READER_ELEMENT_ID, /* verbose */ false);
    }
    return barcodeReaderRef.current;
  };

  // html5-qrcode's scanFile() takes a File; convert the given canvas and scan it.
  const scanCanvasForBarcode = (canvas) =>
    new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Failed to read image"));
            return;
          }
          const file = new File([blob], "barcode-scan.jpg", { type: "image/jpeg" });
          getBarcodeReader()
            .scanFile(file, /* showImage */ false)
            .then(resolve)
            .catch(reject);
        },
        "image/jpeg",
        0.95
      );
    });

  const handleSearchInput = (event) => {
    let i = event.target.value;
    const value = i;
    handleSearch(value);
    setCount = 1;
    setSearchValue(value);
    props.Toggle_Suggestions({ toggle: true });
  };

  useEffect(() => {
    let debounceTimeout;
    if (searchValue?.length >= 3) {
      const isExpress = localStorage.getItem("expressMode");
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(async () => {
        if (!isExpress) {
          await props.searchSuggestions({ search_query: searchValue, store_id: 1 });
        }
      }, 200);
    }
    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [searchValue]);

  const ucwords = (str) => {
    const newString = str.replace(/\//g, "");
    const humanString = newString.replace(/-/g, " ");
    return (humanString + "").replace(/^([a-z])|\s+([a-z])/g, function ($1) {
      return $1.toUpperCase();
    });
  };

  const setSuggestion = (suggestion) => {
    setSearchValue(suggestion);
    setToggleSuggestion(false);
    history.replace(window.location.pathname);
    props.Toggle_Suggestions({ toggle: false });
    setToggleSearch(false);
    if (document.getElementById("closeModal")) {
      document.getElementById("closeModal").click();
    }
  };

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target) && window.matchMedia("all and (min-width: 992px)").matches) {
      setToggleSuggestion(false);
      props.Toggle_Suggestions({ toggle: false });
      setToggleSearch(false);
    }
  };

  const onClearBtnClick = () => {
    setToggleSuggestion(false);
    props.Toggle_Suggestions({ toggle: false });
  };

  const initSearch = () => {
    const textSearch = searchValue.trim().replace(/  +/g, '+');
    logSearchQuery(textSearch);
    window.location.href = `/express/search/${textSearch}`;
  };

  const compressImage = (file, maxSizeKB = 1024) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // Calculate new dimensions to maintain aspect ratio
        let { width, height } = img;
        const maxDimension = 1200; // Max width or height

        if (width > height && width > maxDimension) {
          height = (height * maxDimension) / width;
          width = maxDimension;
        } else if (height > maxDimension) {
          width = (width * maxDimension) / height;
          height = maxDimension;
        }

        canvas.width = width;
        canvas.height = height;

        // Draw and compress
        ctx.drawImage(img, 0, 0, width, height);

        // Start with high quality and reduce until size is acceptable
        let quality = 0.9;
        let compressedDataUrl;

        const compress = () => {
          compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
          const sizeKB = Math.round((compressedDataUrl.length * 3) / 4 / 1024);

          if (sizeKB > maxSizeKB && quality > 0.1) {
            quality -= 0.1;
            compress();
          } else {
            // Convert to blob
            canvas.toBlob((blob) => {
              resolve({
                blob,
                dataUrl: compressedDataUrl,
                originalSize: file.size,
                compressedSize: blob.size
              });
            }, 'image/jpeg', quality);
          }
        };

        compress();
      };

      img.src = URL.createObjectURL(file);
    });
  };

  function validateImage(file) {
    if (!file.type.startsWith("image/")) {
      setError("Please select a valid image file.");
      return false;
    }
    // Remove the 1MB limit check since we'll compress the image
    if (file.size > 10 * 1024 * 1024) { // 10MB limit for original file
      setError("File size must be less than 10MB.");
      return false;
    }
    return true;
  }

  const handleCameraClick = () => {
    if (enterPressed) {
      setEnterPressed(false);
      return;
    }
    // Open modal for image upload options
    setShowModal(true);
  };

  const handleCameraCapture = async (event) => {
    const file = event.target.files?.[0];
    if (!file || !validateImage(file)) return;

    setIsScanning(true);
    setShowModal(true);

    try {
      // Compress the image first
      const compressed = await compressImage(file);

      // Immediately start barcode detection
      const code = await detectBarcodeFromBase64(compressed.dataUrl);

      if (code) {
        setDetectedBarcode(code);
        setPreviewUrl(compressed.dataUrl);
        setSelectedFile(compressed.blob);
        setBase64Image(null);
        setCaptureImage(compressed.dataUrl);
      } else {
        setDetectedBarcode(null);
        setPreviewUrl(compressed.dataUrl);
        setSelectedFile(compressed.blob);
        setBase64Image(compressed.dataUrl);
        setCaptureImage(compressed.dataUrl);
      }
    } catch (error) {
      setError("Failed to process camera image. Please try again.");
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleChangePhoto = () => {
    // Reset all relevant states before triggering file input
    setSelectedFile(null);
    setPreviewUrl("");
    setDetectedBarcode(null);
    setCaptureImage(null);
    setBase64Image(null);
    setError("");
    setIsScanning(false);
    setScanAttempts(0);
    setBarcodeHints('');
    setShowWebCam(false);

    // Trigger file input
    triggerFileInput();
  };

  async function detectBarcodeFromBase64(base64) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64;
      img.onload = async () => {
        try {
          setIsScanning(true);
          setBarcodeHints('Scanning for barcode...');

          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          let result = null;
          let attempts = 0;
          const maxAttempts = 3;

          // Try multiple approaches for better detection
          while (!result && attempts < maxAttempts) {
            attempts++;
            setScanAttempts(attempts);
            setBarcodeHints(`Scan attempt ${attempts}/${maxAttempts}...`);

            try {
              // Attempt 1: Direct scan
              if (attempts === 1) {
                result = await scanCanvasForBarcode(canvas);
              }
              // Attempt 2: Enhanced contrast
              else if (attempts === 2) {
                const enhancedCanvas = enhanceImageForBarcode(canvas, 'contrast');
                result = await scanCanvasForBarcode(enhancedCanvas);
              }
              // Attempt 3: Grayscale and sharpen
              else if (attempts === 3) {
                const enhancedCanvas = enhanceImageForBarcode(canvas, 'sharpen');
                result = await scanCanvasForBarcode(enhancedCanvas);
              }

              if (result) {
                setBarcodeHints(`✅ Barcode detected: ${result}`);
                break;
              }
            } catch (err) {
              console.log(`Scan attempt ${attempts} failed:`, err);
            }

            // Add small delay between attempts
            if (attempts < maxAttempts) {
              await new Promise(resolve => setTimeout(resolve, 300));
            }
          }

          if (!result) {
            setBarcodeHints('❌ No barcode detected. Try adjusting lighting or angle.');
          }

          setTimeout(() => {
            setIsScanning(false);
            setBarcodeHints('');
            setScanAttempts(0);
          }, 2000);

          resolve(result || null);
        } catch (err) {
          setIsScanning(false);
          setBarcodeHints('❌ Scan failed. Please try again.');
          setTimeout(() => setBarcodeHints(''), 2000);
          resolve(null);
        }
      };
    });
  }

  // Image enhancement function for better barcode detection
  function enhanceImageForBarcode(originalCanvas, method = 'contrast') {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = originalCanvas.width;
    canvas.height = originalCanvas.height;

    ctx.drawImage(originalCanvas, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    if (method === 'contrast') {
      // Increase contrast
      const factor = 1.5;
      const intercept = 128 * (1 - factor);

      for (let i = 0; i < data.length; i += 4) {
        data[i] = Math.min(255, Math.max(0, data[i] * factor + intercept));     // Red
        data[i + 1] = Math.min(255, Math.max(0, data[i + 1] * factor + intercept)); // Green
        data[i + 2] = Math.min(255, Math.max(0, data[i + 2] * factor + intercept)); // Blue
      }
    } else if (method === 'sharpen') {
      // Convert to grayscale and apply sharpening
      for (let i = 0; i < data.length; i += 4) {
        const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
        data[i] = gray;
        data[i + 1] = gray;
        data[i + 2] = gray;
      }
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
  }

  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file || !validateImage(file)) return;

    try {
      // Compress the image first
      const compressed = await compressImage(file);

      const img = new Image();
      img.src = compressed.dataUrl;

      img.onload = async () => {
        let code = null;
        try {
          code = await detectBarcodeFromBase64(compressed.dataUrl);
        } catch (err) {
          code = null;
        }

        setDetectedBarcode(code);
        if (code) {
          setBase64Image(null);
          setPreviewUrl(compressed.dataUrl);
          setSelectedFile(compressed.blob);
          setCaptureImage(null);
        } else {
          setBase64Image(compressed.dataUrl);
          setPreviewUrl(compressed.dataUrl);
          setSelectedFile(compressed.blob);
          setCaptureImage(null);
        }
      };
    } catch (error) {
      setError("Failed to process image. Please try another image.");
    }
  };

  // Add utility function to save blob to upload directory
  const saveImageToUploadDir = async (blob, filename) => {
    try {
      const timestamp = Date.now();
      const extension = blob.type.split('/')[1] || 'jpg';
      const uniqueFilename = `${timestamp}_${filename}.${extension}`;

      const formData = new FormData();
      formData.append('image', blob, uniqueFilename);

      const response = await fetch(`${baseUrl}api/v1/upload/searchImage`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to save image');
      }

      const result = await response.json();
      console.log('Image saved:', result);
      return result;
    } catch (error) {
      console.error('Error saving image:', error);
      throw error;
    }
  };

  const handleUpload = async () => {

    if (!selectedFile && !detectedBarcode) {
      alert("No photo or barcode to upload!");
      return;
    }

    setIsUploading(true);
    setError("");

    try {
      let savedImagePath = null;

      if (selectedFile) {
        try {
          savedImagePath = await saveImageToUploadDir(selectedFile, 'search-image');
        } catch (error) {
          setError("Failed to save image. Please try again.");
          setIsUploading(false);
          return;
        }
      }

      const payloadForHistory = {
        limit: 50,
        vector: "",
        filePath: savedImagePath.filePath || '',
        fileName: savedImagePath.fileName || '',
        page: 1,
        barcode: detectedBarcode || "",
      };

      localStorage.setItem("historyState", JSON.stringify(payloadForHistory));

      history.push("/image/search", {
        payload: payloadForHistory,
        imagePath: savedImagePath
      });
      window.location.reload();
      setShowModal(false);
    } catch (err) {
      setError("Failed to upload image.");
      console.error(err);
    } finally {
      setIsUploading(false);
    }
  };

  const handlePaste = async (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    for (const item of items) {
      if (item.type.indexOf("image") !== -1) {
        const blob = item.getAsFile();
        if (!validateImage(blob)) return;

        try {
          // Compress the pasted image
          const compressed = await compressImage(blob);

          const img = new Image();
          img.src = compressed.dataUrl;

          img.onload = async () => {
            let code = null;
            try {
              code = await detectBarcodeFromBase64(compressed.dataUrl);
            } catch (err) {
              code = null;
            }

            setDetectedBarcode(code);
            if (code) {
              setBase64Image(null);
              setPreviewUrl(compressed.dataUrl);
              setSelectedFile(compressed.blob);
              setCaptureImage(null);
            } else {
              setBase64Image(compressed.dataUrl);
              setPreviewUrl(compressed.dataUrl);
              setSelectedFile(compressed.blob);
              setCaptureImage(null);
            }
          };
        } catch (error) {
          setError("Failed to process pasted image. Please try again.");
        }
      }
    }
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files?.[0];
    if (!file || !validateImage(file)) return;

    try {
      // Compress the dropped image
      const compressed = await compressImage(file);

      const img = new Image();
      img.src = compressed.dataUrl;

      img.onload = async () => {
        let code = null;
        try {
          code = await detectBarcodeFromBase64(compressed.dataUrl);
        } catch (err) {
          code = null;
        }

        setDetectedBarcode(code);
        if (code) {
          setBase64Image(null);
          setPreviewUrl(compressed.dataUrl);
          setSelectedFile(compressed.blob);
          setCaptureImage(null);
        } else {
          setBase64Image(compressed.dataUrl);
          setPreviewUrl(compressed.dataUrl);
          setSelectedFile(compressed.blob);
          setCaptureImage(null);
        }
      };
    } catch (error) {
      setError("Failed to process dropped image. Please try another image.");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const resetModalState = () => {
    setSelectedFile(null);
    setPreviewUrl("");
    setError("");
    setIsUploading(false);
    setShowWebCam(false);
    setCaptureImage(null);
    setImageUrl("");
    setIsDragging(false);
    setBase64Image(null);
    setDetectedBarcode(null);
    setIsScanning(false);
    setScanAttempts(0);
    setBarcodeHints('');
    setIsCameraActive(false);
  };

  const handleModalClose = () => {
    setShowModal(false);
    resetModalState();
  };

  function dataURLtoFile(dataUrl, filename) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

	{
		props.cartType === 'express' ?
    Search.defaultProps = {
      bordered: true,
      autoSuggestion: true,
      buttonText: "Search",
      buttonIcon: <FaSearch />,
      inputStyle: {
        width: "100%",
      },
    } :
    Search.defaultProps = {
      bordered: true,
      autoSuggestion: true,
      buttonText: "Search",
      buttonIcon: <FaCamera />,
      inputStyle: {
        width: "100%",
      },
    }
  }

  return (
    <SearchWrapper
      className={className}
      ref={searchRef}
      style={style}
      autoSuggestion={autoSuggestion}
      hideType={hideType}
      expand={expand}
    >
      {/* Hidden container used by html5-qrcode to decode uploaded images */}
      <div
        id={QR_READER_ELEMENT_ID}
        style={{ position: "absolute", width: 0, height: 0, overflow: "hidden", left: "-9999px" }}
      />
      <SearchBoxWrapper
        className={`${hideType ? "hideType" : ""} ${expand === true ? (toggleSearch ? "expanded" : "collapsed") : ""
          } ${minimal === true ? "minimal" : ""}`}
      >
        {props.cartType === 'express'
          ? <InputSearch
            type="text"
            value={value}
            onChange={handleSearchInput}
            onFocus={() => { setToggleSearch(true) }}
            onBlur={() => { setToggleSearch(true) }}
            buttonIcon={buttonIcon}
            buttonText={buttonText}
            style={inputStyle}
            bordered={bordered}
            showSvg={showSvg}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                setEnterPressed(true);
                initSearch();
              }
            }}
            onClick={() => handleCameraClick()}
          />
          : <InputSearch
            type="text"
            value={value}
            onChange={handleSearchInput}
            onFocus={() => {
              props.Toggle_Suggestions({ toggle: true });
            }}
            onBlur={() => { setToggleSearch(true) }}
            buttonIcon={buttonIcon}
            buttonText={buttonText}
            style={inputStyle}
            bordered={bordered}
            showSvg={showSvg}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                setEnterPressed(true);
	              onClick(value);
              }
            }}
            onClick={() => {
              handleCameraClick();
            }}
          />
        }
      </SearchBoxWrapper>

      <Modal
        show={showModal}
        onHide={handleModalClose}
        size="lg"
        centered
        className="google-lens-modal"
      >
        <style jsx>{`
          .modal-content {
            border: none;
            border-radius: 20px;
            box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
            overflow: hidden;
            background: #fff;
            max-width: 90vw;
          }

          .modal-header {
            background: #fff;
            border: none;
            padding: 24px 24px 0;
            position: relative;
            border-bottom: none;
          }

          .modal-title {
            font-family: 'Google Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 22px;
            font-weight: 400;
            color: #202124;
            margin: 0;
            text-align: center;
            width: 100%;
          }

          .btn-close {
            position: absolute;
            right: 16px;
            top: 16px;
            background: none;
            border: none;
            font-size: 24px;
            color: #5f6368;
            cursor: pointer;
            padding: 8px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 1;
            transition: background-color 0.2s ease;
          }

          .btn-close:hover {
            background-color: #f1f3f4;
          }

          .modal-body {
            background: #fff;
            padding: 24px;
            text-align: center;
          }

          .upload-area {
            border: 2px dashed ${isDragging ? '#1a73e8' : '#dadce0'};
            border-radius: 12px;
            padding: 48px 24px;
            margin-bottom: 24px;
            background: ${isDragging ? '#f8f9ff' : '#fafafa'};
            transition: all 0.2s ease;
          }

          .upload-area:hover {
            border-color: #1a73e8;
            background: #f8f9ff;
          }

          .upload-icon {
            width: 48px;
            height: 48px;
            margin: 0 auto 16px;
            background: #e8f0fe;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
          }

          .upload-text {
            font-family: 'Google Sans', -apple-system, BlinkMacSystemFont, sans-serif;
            font-size: 16px;
            color: #3c4043;
            margin-bottom: 8px;
            font-weight: 400;
          }

          .upload-link {
            color: #1a73e8;
            text-decoration: none;
            cursor: pointer;
            font-weight: 500;
          }

          .upload-link:hover {
            text-decoration: underline;
            color: #1557b0;
          }

          .divider-section {
            margin: 24px 0;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .divider-line {
            flex: 1;
            height: 1px;
            background: #dadce0;
          }

          .divider-text {
            padding: 0 16px;
            color: #5f6368;
            font-size: 14px;
            background: #fff;
            font-family: 'Google Sans', sans-serif;
          }

          .url-input-section {
            display: flex;
            gap: 8px;
            align-items: center;
          }

          .url-input {
            flex: 1;
            border: 1px solid #dadce0;
            border-radius: 24px;
            padding: 12px 16px;
            font-size: 14px;
            outline: none;
            font-family: 'Google Sans', sans-serif;
            transition: border-color 0.2s ease;
          }

          .url-input:focus {
            border-color: #1a73e8;
            box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
          }

          .url-input::placeholder {
            color: #80868b;
          }

          .search-btn {
            background: #1a73e8;
            color: #fff;
            border: none;
            border-radius: 20px;
            padding: 12px 24px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            font-family: 'Google Sans', sans-serif;
            transition: background-color 0.2s ease;
          }

          .search-btn:hover {
            background: #1557b0;
          }

          .search-btn:disabled {
            background: #f8f9fa;
            color: #9aa0a6;
            cursor: not-allowed;
          }

          .preview-container {
            text-align: center;
          }

          .preview-image {
            width: 100%;
            max-width: 400px;
            height: auto;
            border-radius: 12px;
            margin-bottom: 16px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .barcode-detection {
            background: #e8f5e8;
            border: 1px solid #34a853;
            border-radius: 8px;
            padding: 12px;
            margin: 16px 0;
            color: #137333;
            font-weight: 500;
            font-family: 'Google Sans', sans-serif;
          }

          .barcode-scanning {
            background: #fff3cd;
            border: 1px solid #ffeaa7;
            border-radius: 8px;
            padding: 16px;
            margin: 16px 0;
            color: #856404;
            font-family: 'Google Sans', sans-serif;
          }

          .scanning-indicator {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
          }

          .scanning-icon {
            font-size: 20px;
            animation: pulse 1.5s ease-in-out infinite;
          }

          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }

          .scan-progress {
            margin-top: 8px;
          }

          .scan-dots {
            display: flex;
            gap: 8px;
            justify-content: center;
          }

          .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #dadce0;
            transition: background 0.3s ease;
          }

          .dot.active {
            background: #1a73e8;
            animation: bounce 0.6s ease;
          }

          @keyframes bounce {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.2); }
          }

          .barcode-hints {
            background: #fff3cd;
            border: 1px solid #ffeaa7;
            border-radius: 8px;
            padding: 12px;
            margin: 16px 0;
            color: #856404;
            font-weight: 500;
            font-family: 'Google Sans', sans-serif;
            text-align: center;
          }

          .preview-buttons {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-top: 20px;
          }

          .btn-secondary {
            background: #fff;
            color: #1a73e8;
            border: 1px solid #dadce0;
            border-radius: 20px;
            padding: 10px 20px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            font-family: 'Google Sans', sans-serif;
            transition: all 0.2s ease;
          }

          .btn-secondary:hover:not(:disabled) {
            background: #f8f9fa;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }

          .btn-primary {
            background: #1a73e8;
            color: #fff;
            border: 1px solid #1a73e8;
            border-radius: 20px;
            padding: 10px 20px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            font-family: 'Google Sans', sans-serif;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .btn-primary:hover:not(:disabled) {
            background: #1557b0;
            border-color: #1557b0;
          }

          .btn-primary:disabled,
          .btn-secondary:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .file-info {
            font-size: 13px;
            color: #5f6368;
            margin-top: 12px;
            font-family: 'Google Sans', sans-serif;
          }

          .spinner {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-top: 2px solid #fff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .webcam-container {
            margin: 16px 0;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }

          @media (max-width: 576px) {
            .modal-content {
              width: 95vw;
              margin: 10px;
            }

              .modal-body {
              padding: 16px;
            }

              .upload-area {
              padding: 32px 16px;
            }

              .preview-buttons {
              flex-direction: column;
              align-items: center;
            }

              .btn-primary,
            .btn-secondary {
              width: 100%;
              max-width: 200px;
            }
          }
        `}</style>

        <Modal.Header closeButton>
          <Modal.Title>Upload Image</Modal.Title>
        </Modal.Header>

        <Modal.Body onPaste={handlePaste}>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />

          <input
            ref={cameraInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleCameraCapture}
            style={{ display: "none" }}
          />

          {!selectedFile && !captureImage ? (
            <div>
              <div
                className="upload-area"
                onClick={triggerFileInput}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <div className="upload-icon">🖼️</div>
                <div className="upload-text">
                  Drag and drop an image here, paste from clipboard, or{" "}
                  <span className="upload-link">upload a file</span>
                </div>
              </div>

              {!deviceType.desktop && (
                <div style={{ marginBottom: "16px", textAlign: "center" }}>
                  <button
                    onClick={() => cameraInputRef.current?.click()}
                    className="btn-primary"
                    style={{ margin: "0 16px" }}
                  >
                    📸 Scan Barcode with Camera
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="preview-container">
              <img
                src={previewUrl}
                alt="Preview"
                className="preview-image"
              />

              {isScanning && (
                <div className="barcode-scanning">
                  <div className="scanning-indicator">
                    <FaQrcode className="scanning-icon" />
                    <span>{barcodeHints}</span>
                    {scanAttempts > 0 && (
                      <div className="scan-progress">
                        <div className="scan-dots">
                          {[...Array(3)].map((_, i) => (
                            <span
                              key={i}
                              className={`dot ${i < scanAttempts ? 'active' : ''}`}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {detectedBarcode && !isScanning && (
                <div className="barcode-detection">
                  🔍 Detected Barcode: <strong>{detectedBarcode}</strong>
                </div>
              )}

              {!detectedBarcode && !isScanning && barcodeHints && (
                <div className="barcode-hints">
                  {barcodeHints}
                </div>
              )}

              <div className="preview-buttons">
                <button
                  onClick={handleChangePhoto}
                  className="btn-secondary"
                  disabled={isUploading}
                >
                  Change Photo
                </button>
                <button
                  onClick={handleUpload}
                  className="btn-primary"
                  disabled={isUploading}
                  onTouchEnd={handleUpload}
                >
                  {isUploading ? (
                    <>
                      <div className="spinner"></div>
                      Uploading...
                    </>
                  ) : (
                    <>📤 Upload Photo</>
                  )}
                </button>
              </div>

              <div className="file-info">
                {selectedFile
                  ? `File: ${selectedFile instanceof Blob ? 'Compressed Image' : selectedFile.name} (${Math.round(selectedFile.size / 1024)}KB)`
                  : `Captured from camera`}
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {autoSuggestion && (props.togglesuggestion) && !window.location.pathname.includes("/express") ? (
        <SearchResults
          suggestions={suggestions}
          clearSearch={onClearBtnClick}
          setSuggestionValue={(suggestion) => setSuggestion(suggestion)}
          search={searchValue}
          props={props}
        />
      ) : null}
    </SearchWrapper>
  );
};

Search.defaultProps = {
  bordered: true,
  autoSuggestion: true,
  buttonText: "Search",
  buttonIcon: <FaCamera />,
  inputStyle: {
    width: "100%",
  },
};

Search.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};

export default Search;